/**
 * @file     languages.ts
 * @readme   ./CLAUDE.md
 * @purpose  Declares the supported language list, RTL languages, AppLanguage type, and display name/flag mappings for the language picker.
 */
export const supportedLanguages = ['en', 'fr', 'hi', 'fa', 'ar', 'pt', 'es', 'ru', 'pa', 'ur'] as const;

export type AppLanguage = (typeof supportedLanguages)[number];

export const defaultLanguage: AppLanguage = 'en';

export const rtlLanguages: AppLanguage[] = ['ar', 'fa', 'ur'];

export const languageNames: Record<AppLanguage, string> = {
  en: 'English',
  fr: 'French',
  hi: 'Hindi',
  fa: 'Persian',
  ar: 'Arabic',
  pt: 'Portuguese',
  es: 'Spanish',
  ru: 'Russian',
  pa: 'Punjabi',
  ur: 'Urdu'
};

export const languageFlags: Record<AppLanguage, string> = {
  en: '🇬🇧',
  fr: '🇫🇷',
  hi: '🇮🇳',
  fa: '🇮🇷',
  ar: '🇸🇦',
  pt: '🇵🇹',
  es: '🇪🇸',
  ru: '🇷🇺',
  pa: '🇮🇳',
  ur: '🇵🇰'
};

export const getLanguageOptionLabel = (language: AppLanguage) => {
  return languageNames[language];
};
